import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DeactivateOrDeleteAccountSharedModule } from '../deactivate-or-delete-account-shared/deactivate-or-delete-account-shared.module';
import { DeactivateAccountModalComponent } from './deactivate-account-modal.component';

@NgModule({
  imports: [
    CommonModule,
    DeactivateOrDeleteAccountSharedModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [DeactivateAccountModalComponent],
  exports: [DeactivateAccountModalComponent],
})
export class DeactivateAccountModalModule {}
